import AuctionContract from './Auction.json';
import BulletCollectorTokenKeeperContract from './BulletCollectorTokenKeeper.json';
import ContractGeneratorContract from './ContractGenerator.json';
import DOBContract from './DOB.json';
import DOBStakingPoolContract from './DOBStakingPool.json';
import DistributionsContract from './Distributions.json';
import GoldGeregeContract from './GoldGerege.json';
import HODLStakingPoolRewarderContract from './HODLStakingPoolRewarder.json';
import HODLStakingPoolsContract from './HODLStakingPools.json';
import MatchingMarketContract from './MatchingMarket.json';
// import NFTContract from './NFT.json';
import OptionFactoryContract from './OptionFactory.json';
import RewardDispatcherTokenKeeperContract from './rewardDispatcherTokenKeeper.json';
import SilverGeregeContract from './SilverGerege.json';
import StakingPoolRewarderContract from './StakingPoolRewarder.json';
import StakingPoolsContract from './StakingPools.json';
// import TokenFactoryContract from './TokenFactory.json';
import TestTokenPoolContract from './TestTokenPool.json';
import TokenKeeperContract from './TokenKeeper.json';
import USDCContract from './USDC.json';
import WBTCContract from './WBTC.json';
import WETHContract from './WETH.json';
import bHODLContract from './bHODL.json';
import bHODLRewarderContract from './bHODLRewarder.json';
import feeCollectorTokenKeeperContract from './feeCollectorTokenKeeper.json';
import uHODLContract from './uHODL.json';
import uHODLRewarderContract from './uHODLRewarder.json';
export const AuctionAddressEthSepolia = AuctionContract.address;
export const BulletCollectorTokenKeeperAddressEthSepolia = BulletCollectorTokenKeeperContract.address;
export const ContractGeneratorAddressEthSepolia = ContractGeneratorContract.address;
export const DOBAddressEthSepolia = DOBContract.address;
export const DOBStakingPoolAddressEthSepolia = DOBStakingPoolContract.address;
export const DistributionsAddressEthSepolia = DistributionsContract.address;
export const GoldGeregeAddressEthSepolia = GoldGeregeContract.address;
export const HODLStakingPoolRewarderAddressEthSepolia = HODLStakingPoolRewarderContract.address;
export const HODLStakingPoolsAddressEthSepolia = HODLStakingPoolsContract.address;
export const MatchingMarketAddressEthSepolia = MatchingMarketContract.address;
// export const NFTAddressEthSepolia = NFTContract.address;
export const OptionFactoryAddressEthSepolia = OptionFactoryContract.address;
export const RewardDispatcherTokenKeeperAddressEthSepolia = RewardDispatcherTokenKeeperContract.address;
export const SilverGeregeAddressEthSepolia = SilverGeregeContract.address;
export const StakingPoolRewarderAddressEthSepolia = StakingPoolRewarderContract.address;
export const StakingPoolsAddressEthSepolia = StakingPoolsContract.address;
// export const TokenFactoryAddressEthSepolia = TokenFactoryContract.address;
export const TestTokenPoolAddressEthSepolia = TestTokenPoolContract.address;
export const TokenKeeperAddressEthSepolia = TokenKeeperContract.address;
export const USDCAddressEthSepolia = USDCContract.address;
export const WBTCAddressEthSepolia = WBTCContract.address;
export const WETHAddressEthSepolia = WETHContract.address;
export const bHODLAddressEthSepolia = bHODLContract.address;
export const bHODLRewarderAddressEthSepolia = bHODLRewarderContract.address;
export const feeCollectorTokenKeeperAddressEthSepolia = feeCollectorTokenKeeperContract.address;
export const uHODLAddressEthSepolia = uHODLContract.address;
export const uHODLRewarderAddressEthSepolia = uHODLRewarderContract.address;
//# sourceMappingURL=index.js.map